import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { ROLE_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { employee_get_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";

interface FormErrors {
  [key: string]: string | null;
}
interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  role_name: Yup.string()
    .required("Required")
    .min(2, "Role name must be at least 2 characters"),
  users: Yup.array(),
});
const RoleForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });
  const { closeModal } = useSiteContext();
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    employee_get_select((data: any) => setAllUsers(data));
  }, []);

  //   const onSubmit = (data: any) => {
  //     console.log("Form submitted:", data);
  //   };
  const onSubmit = (data: any) => {
    let url = ROLE_URLS.INSERT;
    if (data.ID !== undefined) {
      data["id"] = data.ID;
      url = ROLE_URLS.UPDATE;
    }
    const subscription = post(url, data).subscribe((response) => {
      //console.log("response form ", response.data);
      closeModal();
      loadTableData();
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const options = [
    { value: "1", label: "Test" },
    { value: "2", label: "Test" },
    { value: "3", label: "test" },
  ];
  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "role_name",
      element: {
        label: "Role Name",
        isRequired: true,
        disabled: dataIn?.ID ? true : false,
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "SELECT_BOX",
      width: 12,
      name: "users",
      element: {
        label: "Users",
        isMulti: true,
        options: allUsers,
        // isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn.ID ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-hims-input">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default RoleForm;
